var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDottedGrid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7499 5.62004C11.2102 5.62004 11.5833 5.24694 11.5833 4.7867C11.5833 4.32647 11.2102 3.95337 10.7499 3.95337C10.2897 3.95337 9.91659 4.32647 9.91659 4.7867C9.91659 5.24694 10.2897 5.62004 10.7499 5.62004Z",
    stroke: "#474B52",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7499 11.4534C11.2102 11.4534 11.5833 11.0803 11.5833 10.62C11.5833 10.1598 11.2102 9.7867 10.7499 9.7867C10.2897 9.7867 9.91659 10.1598 9.91659 10.62C9.91659 11.0803 10.2897 11.4534 10.7499 11.4534Z",
    stroke: "#474B52",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7499 17.2867C11.2102 17.2867 11.5833 16.9136 11.5833 16.4534C11.5833 15.9931 11.2102 15.62 10.7499 15.62C10.2897 15.62 9.91659 15.9931 9.91659 16.4534C9.91659 16.9136 10.2897 17.2867 10.7499 17.2867Z",
    stroke: "#474B52",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5833 5.62004C17.0435 5.62004 17.4166 5.24694 17.4166 4.7867C17.4166 4.32647 17.0435 3.95337 16.5833 3.95337C16.123 3.95337 15.7499 4.32647 15.7499 4.7867C15.7499 5.24694 16.123 5.62004 16.5833 5.62004Z",
    stroke: "#474B52",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5833 11.4534C17.0435 11.4534 17.4166 11.0803 17.4166 10.62C17.4166 10.1598 17.0435 9.7867 16.5833 9.7867C16.123 9.7867 15.7499 10.1598 15.7499 10.62C15.7499 11.0803 16.123 11.4534 16.5833 11.4534Z",
    stroke: "#474B52",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5833 17.2867C17.0435 17.2867 17.4166 16.9136 17.4166 16.4534C17.4166 15.9931 17.0435 15.62 16.5833 15.62C16.123 15.62 15.7499 15.9931 15.7499 16.4534C15.7499 16.9136 16.123 17.2867 16.5833 17.2867Z",
    stroke: "#474B52",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.91659 5.62004C5.37682 5.62004 5.74992 5.24694 5.74992 4.7867C5.74992 4.32647 5.37682 3.95337 4.91659 3.95337C4.45635 3.95337 4.08325 4.32647 4.08325 4.7867C4.08325 5.24694 4.45635 5.62004 4.91659 5.62004Z",
    stroke: "#474B52",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.91659 11.4534C5.37682 11.4534 5.74992 11.0803 5.74992 10.62C5.74992 10.1598 5.37682 9.7867 4.91659 9.7867C4.45635 9.7867 4.08325 10.1598 4.08325 10.62C4.08325 11.0803 4.45635 11.4534 4.91659 11.4534Z",
    stroke: "#474B52",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.91659 17.2867C5.37682 17.2867 5.74992 16.9136 5.74992 16.4534C5.74992 15.9931 5.37682 15.62 4.91659 15.62C4.45635 15.62 4.08325 15.9931 4.08325 16.4534C4.08325 16.9136 4.45635 17.2867 4.91659 17.2867Z",
    stroke: "#474B52",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDottedGrid);
export default __webpack_public_path__ + "static/media/dottedGrid.5732a316a9a9f8d8ad6aae20e52be77e.svg";
export { ForwardRef as ReactComponent };